export default "__VITE_ASSET__CgVvKdmR__"